import HighlightEmbed from '../quill/highlightEmbed';

export default {
  props: {
    highlight: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    if (this.readonly) {
      // 时间紧张，临时方案，后续会重写，暂时只在只读中显示高亮
      setTimeout(() => {
        // 初始化完成
        this.highlight?.length && this.setHighlight();
      }, 0);
    }
  },
  methods: {
    setHighlight() {
      this.highlight.forEach(({ position }) => {
        const range = {
          start: position[0],
          length: position[1] - position[0],
        };

        const formatsCache = this.quill.getContents(range.start, range.length);
        const text = this.quill.getText(range.start, range.length);
        this.quill.deleteText(range.start, range.length);
        // 插入错误标签
        this.quill.insertEmbed(range.start, HighlightEmbed.blotName, {
          value: text,
        });
        // 恢复原有的样式
        this.recoverFormat(range, formatsCache);
      });
    },
  },
};
